<template>
  <Modal
    class="tw-translate-y-[-50%]"
    :max-width="DEFAULT_MAX_WIDTH_MODAL"
    :visible="showRef"
    :value="form"
    :close-on-esc="!isShowResendTokenModal"
    :is-hide-overlay="hideOverlay"
    @close="handleCloseModal"
  >
    <ModalHeader
      :title="
        type === requestAccessDetailModalType.editRequest
          ? getComponentUiText(
              'app-settings-organisation-manage-access-edit-org-modal-title-1',
            )
          : getComponentUiText(
              'app-settings-organisation-manage-access-create-org-modal-title-1',
            )
      "
      class-name="!tw-text-[18px]"
      @close="handleCloseModal"
    />
    <div class="divider" />
    <div class="tw-p-[40px] modal-create-org">
      <BaseForm :show="showRef" :enter-event="true" @on:submit="onSubmit">
        <div class="manage-role tw-bg-white">
          <div
            class="table-header tw-flex tw-flex-col md:tw-flex-row md:tw-items-center tw-justify-start md:tw-justify-between"
          >
            <span
              class="tw-text-[#211F58] tw-font-semibold tw-flex-1 tw-text-xl"
              >{{
                getComponentUiText(
                  "app-settings-organisation-manage-access-create-org-modal-title-2",
                )
              }}</span
            >
          </div>
          <div>
            <!-- Email -->
            <BaseInput
              v-if="isCreateOrg"
              v-model="form.emailDomain"
              :validation="v$.emailDomain"
              :placeholder="
                getComponentUiText(
                  'app-settings-organisation-manage-access-create-org-modal-email-domain-prompt-1',
                )
              "
              :label="
                getComponentUiText('app-settings-organisation-domain-title-1')
              "
              @blur="
                () => {
                  v$.emailDomain.$validate();
                }
              "
            >
              <div class="input-base-form-input tw-text-[#B7B7B7]">
                {{ form.emailDomain }}
              </div>
            </BaseInput>

            <!-- Org contact -->
            <BaseInput
              v-else
              v-model="form.orgContact"
              :validation="v$.orgContact"
              :placeholder="
                getComponentUiText(
                  'app-settings-organisation-manage-access-create-org-modal-org-contact-prompt-1',
                )
              "
              :label="
                getComponentUiText(
                  'app-settings-organisation-manage-access-create-org-modal-org-contact-1',
                )
              "
              :label-tooltip="
                getComponentUiText(
                  'app-settings-organisation-contact-label-tooltip-1',
                )
              "
              @blur="
                () => {
                  v$.orgContact.$validate();
                }
              "
            >
              <template #rightTitle>
                <ButtonShowDuplicateAssessment
                  :id-popover="'popover-btn-show-duplicate-create-org-modal'"
                  :custom-class="'tw-max-w-[470px] '"
                  :classes="'!tw-leading-[unset] tw-ml-[6px]'"
                >
                  <div class="tw-p-[15px] tw-w-[247px]">
                    <div
                      class="tw-flex tw-items-center tw-text-[#211f58] tw-font-[Poppins] tw-text-[12px] tw-font-medium tw-leading-[100%] tw-not-italic"
                    >
                      {{
                        getComponentUiText(
                          "app-settings-organisation-manage-access-create-org-modal-org-contact-1",
                        )
                      }}
                    </div>
                    <div
                      class="tw-mt-[10px] tw-text-[11px] tw-font-[400] tw-text-[#878787] tw-font-[Poppins]"
                    >
                      {{
                        getComponentUiText(
                          "app-settings-organisation-contact-description-tooltip-1",
                        )
                      }}
                    </div>
                  </div>
                </ButtonShowDuplicateAssessment>
              </template>
            </BaseInput>

            <!-- make contact a super admin -->
            <BaseInput
              v-if="type !== requestAccessDetailModalType.createOrg"
              v-model="form.makeSuperAdmin"
              :validation="v$.makeSuperAdmin"
              :placeholder="
                getComponentUiText(
                  'app-settings-organisation-manage-access-create-org-modal-require-mfa-for-all-users-1',
                )
              "
              :label="
                getComponentUiText(
                  'app-settings-organisation-create-request-make-contact-title-1',
                )
              "
            >
              <CustomSwitchCheckbox
                v-model="form.makeSuperAdmin"
                :checked="form.makeSuperAdmin"
                class="tw-mb-0"
                class-name="grey-slider"
                @update:checkbox="(value) => (form.makeSuperAdmin = value)"
              />
            </BaseInput>

            <!-- Name Code -->
            <BaseInput
              v-model="form.nameCode"
              :validation="
                form.nameCode?.length >= 4 || nameCodeBlurred
                  ? v$.nameCode
                  : { required: () => {}, $touch: () => {}, $reset: () => {} }
              "
              :placeholder="
                getComponentUiText(
                  'app-settings-organisation-manage-access-create-org-modal-name-code-prompt-1',
                )
              "
              :label="
                getComponentUiText(
                  'app-settings-organisation-manage-access-create-org-modal-name-code-1',
                )
              "
              :label-tooltip="
                getComponentUiText(
                  'app-settings-organisation-manage-access-create-org-modal-name-code-tooltip-1',
                )
              "
              @blur="
                () => {
                  v$.nameCode.$validate();
                  nameCodeBlurred = true;
                }
              "
              @focus="() => (nameCodeBlurred = false)"
            />

            <!-- Org Relationship -->
            <BaseInput
              v-if="isCreateOrg"
              id="orgToOrgTypeId"
              v-model="form.orgToOrgTypeId"
              :validation="v$.orgToOrgTypeId"
              :placeholder="
                getComponentUiText(
                  'app-settings-organisation-manage-access-create-org-modal-org-relationship-prompt-1',
                )
              "
              :label="
                getComponentUiText(
                  'app-settings-organisation-manage-access-create-org-modal-org-relationship-1',
                )
              "
            >
              <BaseDropDown
                :id="'domain'"
                v-model="form.orgToOrgTypeId"
                :data="orgToOrgTypeIdOptions"
                :validation="v$.orgToOrgTypeId"
                :class-name="'gray-dropdown-container tw-h-[58px]'"
                :placeholder="
                  getComponentUiText(
                    'app-settings-organisation-manage-access-create-org-modal-org-relationship-prompt-1',
                  )
                "
                @update:model-value="() => (form.isLocked = true)"
              />
            </BaseInput>

            <!-- Lock Status -->
            <BaseInput
              v-if="handleLockStatus()"
              id="lock-status"
              v-model="form.isLocked"
              :validation="v$.isLocked"
              :label="
                getComponentUiText(
                  'app-settings-organisation-manage-access-modals-label-lock-status-1',
                )
              "
              :label-tooltip="
                getComponentUiText(
                  'app-settings-organisation-manage-access-offer-modal-description-lock-status-1',
                )
              "
              :validate-on-blur="true"
            >
              <BaseDropDown
                :id="'isLocked'"
                v-model="form.isLocked"
                :data="lockStatusOptions"
                :validation="v$.isLocked"
                :class-name="'gray-dropdown-container tw-h-[58px]'"
                :placeholder="
                  getComponentUiText(
                    'app-settings-organisation-manage-access-modals-prompt-lock-status-1',
                  )
                "
              >
                <template #button-content>
                  <div class="tw-flex tw-justify-between">
                    <div>
                      <img
                        v-if="form.isLocked"
                        class="tw-h-[14px] tw-w-[14px] tw-mr-[10px]"
                        src="/img/lock1_icon.svg"
                        alt="icon"
                      />
                      <span :class="'tw-text-[#231F20]'">{{
                        lockStatusOptions.find((m) => m.id === form.isLocked)
                          ?.name
                      }}</span>
                    </div>
                    <img
                      class="right-arrow"
                      src="/img/blue_right_arrow_icon.svg"
                    />
                  </div>
                </template>
              </BaseDropDown>

              <template #feedback>
                <div
                  v-if="form.isLocked === false"
                  class="tw-flex tw-bg-[#FE9A0526] tw-text-[11px] tw-text-[#FE9A05] tw-font-medium tw-mt-[10px] tw-leading-[130%] tw-py-[8px] tw-px-[12px] tw-rounded-md"
                >
                  <div class="tw-flex tw-item-center tw-mr-[10px]">
                    <img src="@/assets/img/warning-orange-icon.svg" />
                  </div>
                  <span>{{
                    getComponentUiText(
                      "app-settings-organisation-manage-access-modals-warning-lock-status-1",
                    )
                  }}</span>
                </div>
              </template>
            </BaseInput>

            <!-- Super Admin Users -->
            <BaseInput
              v-if="isCreateOrg"
              id="'superAdminUser'"
              v-model="form.superAdminIds"
              :validation="v$.superAdminIds"
              :placeholder="
                getComponentUiText(
                  'app-settings-organisation-manage-access-create-org-modal-super-admin-users-1',
                )
              "
              :label="
                getComponentUiText(
                  'app-settings-organisation-manage-access-create-org-modal-super-admin-users-1',
                )
              "
            >
              <BaseMultiDropDown
                :id="'superAdminMultiDropDown'"
                v-model="form.superAdminIds"
                :data="superAdminUsers"
                :validation="v$.superAdminIds"
                :class-name="'gray-dropdown-container tw-min-h-[58px] tw-text-[#FFFFFF]'"
                :placeholder="
                  getComponentUiText(
                    'app-settings-organisation-manage-access-create-org-modal-super-admin-users-prompt-1',
                  )
                "
              />
            </BaseInput>
            <div class="divider tw-mt-[35px] tw-mb-[35px]" />

            <!-- Legal name -->
            <BaseInput
              v-model="form.nameLegal"
              :validation="v$.nameLegal"
              :placeholder="
                getComponentUiText(
                  'app-settings-organisation-manage-access-create-org-modal-legal-name-prompt-1',
                )
              "
              :label="
                getComponentUiText(
                  'app-settings-organisation-manage-access-create-org-modal-legal-name-prompt-1',
                )
              "
            />

            <!-- Display name -->
            <BaseInput
              v-model="form.nameDisplay"
              :validation="v$.nameDisplay"
              :placeholder="
                getComponentUiText(
                  'app-settings-organisation-manage-access-create-org-modal-display-name-prompt-1',
                )
              "
              :label="
                getComponentUiText(
                  'app-settings-organisation-manage-access-create-org-modal-display-name-1',
                )
              "
              :label-tooltip="
                getComponentUiText(
                  'app-settings-organisation-manage-access-create-org-modal-display-name-tooltip-1',
                )
              "
            />

            <!-- Require MFA -->
            <BaseInput
              v-if="isCreateOrg"
              v-model="form.requireMFA"
              :placeholder="
                getComponentUiText(
                  'app-settings-organisation-manage-access-create-org-modal-require-mfa-for-all-users-1',
                )
              "
              :label="
                getComponentUiText(
                  'app-settings-organisation-manage-access-create-org-modal-require-mfa-for-all-users-1',
                )
              "
            >
              <CustomSwitchCheckbox
                v-model="form.requireMFA"
                :checked="form.requireMFA"
                class="tw-mb-0"
                class-name="grey-slider"
                @update:checkbox="(value) => (form.requireMFA = value)"
              />
            </BaseInput>
          </div>
        </div>

        <div class="tw-flex tw-justify-end tw-mt-[40px]">
          <ButtonLoading
            class="create-organisation-button !tw-items-center tw-bg-[#387DFF] tw-text-[15px] tw-font-medium tw-rounded-[27px]"
            :class="`${isCallApi ? 'tw-p-0' : 'tw-py-[11px] tw-px-[18px]'}`"
            data-cy="header-save-change-button"
            :title="
              getComponentUiText(
                isCreateOrg
                  ? 'app-settings-organisation-manage-access-create-org-modal-submit-button-1'
                  : type === requestAccessDetailModalType.createRequest
                    ? 'app-settings-organisation-manage-access-create-org-modal-button-title-request-verification-1'
                    : 'app-settings-organisation-manage-access-create-org-modal-button-title-update-request-1',
              )
            "
            :is-loading="isCallApi"
          />
        </div>
      </BaseForm>
    </div>
  </Modal>
</template>

<script setup lang="ts">
import { Ref, onMounted, computed, reactive, ref, watch, PropType } from "vue";
import useVuelidate from "@vuelidate/core";
import {
  required,
  helpers,
  minLength,
  maxLength,
  alphaNum,
} from "@vuelidate/validators";
import { tlDomain } from "@/utils/validationRules";

import Modal from "../common/modal.vue";
import ModalHeader from "../common/modalHeader.vue";
import BaseInput from "@/components/common/form/baseInput.vue";
import {
  IsEmailValidWhileTyping,
  IsSpecialCharDomainValid,
  IsSpecialCharEmailValid,
  getComponentUiText,
} from "@/utils/utilities";
import CustomSwitchCheckbox from "@/components/common/customSwitchCheckbox.vue";
import BaseDropDown from "@/components/common/form/baseDropDown.vue";
import { IDropDownData } from "@/interfaces/common/IDropDown";
import BaseMultiDropDown from "@/components/common/form/baseMultiDropDown.vue";
import BaseForm from "@/components/common/form/baseForm.vue";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import {
  IOrgCreateRequest,
  IOrgVerificationCreate,
  IOrgVerificationCreateOrg,
} from "@/interfaces/orgInterfaces";
import {
  fetchOrgAccessType,
  postOrgCreate,
  postVerificationRequestOrgCreate,
  getOrgDomainsInvalid,
  getOrgMembersAddable,
  putVerificationRequestOrg,
} from "@/services/org";
import store from "@/store";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import get from "lodash/get";
import commonServices from "@/services/common/commonServices";
import utilities from "@/utils/utilities";
import { showErrorAPI } from "@/services/apiRoutes";
import { Org } from "@/services/apiRoutes/routes";
import { MODAL_NAME, requestAccessDetailModalType } from "@/utils/constants";
import { email } from "@vuelidate/validators";
import ButtonShowDuplicateAssessment from "../common/setting/buttonShowDuplicateAssessment.vue";
import { IModalMessage } from "@/interfaces/common/common";
import ButtonLoading from "../common/buttonLoading.vue";

const DEFAULT_MAX_WIDTH_MODAL = 65;
const commonService = new commonServices();
const props = defineProps({
  show: {
    type: Boolean,
    required: false,
  },
  type: {
    type: String as PropType<keyof typeof requestAccessDetailModalType>,
    required: false,
    default: requestAccessDetailModalType.createRequest,
  },
  data: {
    type: Object,
    required: false,
    default: () => ({}),
  },
  orgData: {
    type: Object as PropType<any>,
    required: false,
    default: () => ({}),
  },
  hideOverlay: {
    type: Boolean,
    required: false,
    default: true,
  },
});
const isCreateOrg = props.type === requestAccessDetailModalType.createOrg;
const isShowResendTokenModal = ref(false);
let messageSuccess = getComponentUiText(
  "app-settings-organisation-manage-toast-org-created-1",
);
const emit = defineEmits(["update:show", "update:domain"]);
let showRef = ref(props.show);
let notInfoVisible = ref(true);
let invalidDomain: Ref<string[]> = ref([]);
const orgToOrgTypeIdOptions: Ref<IDropDownData[]> = ref([]);
const nameCodeBlurred: Ref<boolean> = ref(false);

const lockStatusOptions: IDropDownData[] = [
  {
    id: true,
    name: getComponentUiText(
      "app-settings-organisation-manage-access-create-org-modal-locked-status-1",
    ),
    iconSrc: "/img/lock1_icon.svg",
  },
  {
    id: false,
    name: getComponentUiText(
      "app-settings-organisation-manage-access-create-org-modal-unlocked-status-1",
    ),
  },
];

const validateForDomain = (text: string) => {
  return !invalidDomain.value.some((domain) => text.includes(domain));
};

const initialForm = computed<IOrgCreateRequest>(() => {
  return {
    orgVerifyId: props.orgData?.id || "",
    emailDomain: props.orgData?.domain || "",
    orgContact: props.orgData?.email || "",
    makeSuperAdmin: isCreateOrg ? null : !!props.orgData?.makeSuperAdmin,
    nameCode: props.orgData?.nameCode || "",
    orgToOrgTypeId: "",
    isLocked: true,
    superAdminIds: [],
    nameLegal: props.orgData?.nameLegal || "",
    nameDisplay: props.orgData?.nameShort || "",
    requireMFA: false,
  };
});

const form = reactive<any>({ ...initialForm.value });

onMounted(() => {
  form.value = { ...initialForm.value };
});

watch(
  () => initialForm,
  () => {
    form.value = { ...initialForm.value };
  },
);

const rulesOrg = {
  emailDomain: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
    domain: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-settings-organisation-manage-access-create-org-modal-email-domain-invalid-1",
        ),
      tlDomain,
    ),
    specialChar: helpers.withMessage(
      () =>
        getComponentUiText("app-base-input-email-invalid-special-characters-1"),
      IsSpecialCharDomainValid,
    ),
    invalid: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-settings-organisation-manage-access-create-org-modal-email-domain-invalid-2",
          false,
          {
            moreDetails: `<a class='tw-underline' href='#'>${getComponentUiText(
              "app-settings-organisation-manage-access-create-org-modal-email-domain-more-details-1",
            )}</span>`,
          },
        ),
      validateForDomain,
    ),
  },
  nameCode: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
    minLength: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-settings-organisation-manage-access-create-org-modal-name-code-invalid-2",
        ),
      minLength(2),
    ),
    maxLength: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-settings-organisation-manage-access-create-org-modal-name-code-invalid-2",
        ),
      maxLength(4),
    ),
    alphaNum: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-settings-organisation-manage-access-create-org-modal-name-code-invalid-2",
        ),
      alphaNum,
    ),
  },
  orgToOrgTypeId: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
  },
  isLocked: {},
  superAdminIds: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
    minLength: minLength(1),
  },
};

const rulesRequest = {
  orgContact: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
    specialChar: helpers.withMessage(
      () =>
        getComponentUiText("app-base-input-email-invalid-special-characters-1"),
      IsEmailValidWhileTyping,
    ),
    email: helpers.withMessage(
      () =>
        getComponentUiText("app-base-input-email-invalid-special-characters-1"),
      IsSpecialCharEmailValid,
    ),
  },
  makeSuperAdmin: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
  },
  nameCode: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
    minLength: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-settings-organisation-manage-access-create-org-modal-name-code-invalid-2",
        ),
      minLength(2),
    ),
    maxLength: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-settings-organisation-manage-access-create-org-modal-name-code-invalid-2",
        ),
      maxLength(4),
    ),
    alphaNum: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-settings-organisation-manage-access-create-org-modal-name-code-invalid-2",
        ),
      alphaNum,
    ),
  },
};

const fetchOrgDomainsInvalid = async () => {
  try {
    if (invalidDomain.value?.length > 0) return invalidDomain.value;
    const res = await getOrgDomainsInvalid();
    if (res && res.data && res.data.data) return res.data.data;
    else return [];
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Org.getOrgDomainsInvalid);
    }
  }
};

const updateValidateRules = async () => {
  invalidDomain.value = isCreateOrg ? await fetchOrgDomainsInvalid() : [];
};

let v$ = isCreateOrg
  ? useVuelidate(rulesOrg, form)
  : useVuelidate(rulesRequest, form);
const currentOrg = computed(() => store.state.Org.currentOrg);
const superAdminUsers: Ref<IDropDownData[]> = ref([]);

watch(
  () => form.nameCode,
  (value) => {
    if (!utilities.regexMatch(/^[a-z0-9]+$/i, value)) {
      nameCodeBlurred.value = true;
    } else {
      nameCodeBlurred.value = false;
    }
  },
);

const isCallApi = ref(false);

const onSubmit = async () => {
  await v$.value.$validate();
  nameCodeBlurred.value = true;
  if (v$.value.$invalid) return;

  try {
    isCallApi.value = true;
    switch (props.type) {
      case requestAccessDetailModalType.createOrg: {
        await createOrg();
        break;
      }
      case requestAccessDetailModalType.createRequest: {
        await createRequest();
        break;
      }
      case requestAccessDetailModalType.editRequest: {
        if (form.orgContact === props.orgData?.email) {
          openResendTokenModal(form);
        } else {
          editRequest(true);
        }
        break;
      }
    }
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Org.putOrgProfile);
    }
  } finally {
    isCallApi.value = false;
  }
};

const openResendTokenModal = (data: any) => {
  isShowResendTokenModal.value = true;
  const emitData: IModalMessage = {
    component: MODAL_NAME.RESEND_TOKEN_MODAL,
    properties: {
      isMoreInfoModal: true,
    },
    events: {
      "update:close": () => {
        isShowResendTokenModal.value = false;
      },
      "update:resend": () => {
        editRequest(true);
      },
      "update:only": () => {
        editRequest(false);
      },
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const editRequest = async (sendNewToken: boolean) => {
  try {
    const formData = {
      email: form.orgContact,
      nameCode: form.nameCode,
      makeSuperAdmin: !!form.makeSuperAdmin,
      nameLegal: form.nameLegal,
      nameShort: form.nameDisplay,
      sendNewToken,
    };
    const formSubmit = commonService.removePropertyEmpty(formData);
    if (props.orgData.id) {
      const formResponse = await putVerificationRequestOrg(
        props.orgData.id,
        formSubmit,
      );

      if (formResponse.data?.data) {
        handleCloseModal();
        if (sendNewToken) {
          EventEmitter.emit(
            EmitterEvents.APP_MODAL_MANAGE_ORGANISATIONS_VISIBILITY,
            form.nameDisplay || form.nameCode,
          );
          onShowToast(
            getComponentUiText(
              "app-settings-org-manage-toast-org-request-verification-created-1",
            ),
            ToastVariant.SUCCESS,
          );
        } else {
          store.dispatch("Org/fetchOrgListVerify");
          onShowToast(
            getComponentUiText(
              "app-settings-organisation-manage-toast-org-request-verification-edited-1",
            ),
            ToastVariant.SUCCESS,
          );
        }
      }
    }
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Org.editRequestVerification);
    }
  }
};

const createRequest = async () => {
  try {
    const formData: IOrgVerificationCreate = {
      email: form.orgContact,
      nameCode: form.nameCode,
      makeSuperAdmin: !!form.makeSuperAdmin,
      nameLegal: form.nameLegal,
      nameShort: form.nameDisplay,
    };
    const formSubmit = commonService.removePropertyEmpty(formData);
    const formResponse = await postVerificationRequestOrgCreate(formSubmit);

    if (formResponse.data?.data) {
      onShowToast(
        getComponentUiText(
          "app-settings-org-manage-toast-org-request-verification-created-1",
        ),
        ToastVariant.SUCCESS,
      );
      handleCloseModal();
      EventEmitter.emit(
        EmitterEvents.APP_MODAL_MANAGE_ORGANISATIONS_VISIBILITY,
        form.nameDisplay || form.nameCode,
      );
      store.dispatch("Org/fetchOrgListVerify");
    }
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Org.createRequestVerification);
    }
  }
};

const createOrg = async () => {
  try {
    const formData: IOrgVerificationCreateOrg = {
      orgVerifyId: form.orgVerifyId,
      orgToOrgTypeId: form.orgToOrgTypeId,
      nameCode: form.nameCode,
      makeVerifiedEmailSuperAdmin: !!form.makeSuperAdmin,
      nameLegal: form.nameLegal,
      nameDisplay: form.nameDisplay,
      isLocked: form.isLocked,
    };
    const formSubmit = commonService.removePropertyEmpty(formData);
    const formResponse = await postOrgCreate(formSubmit);

    if (formResponse.data?.data) {
      onShowToast(messageSuccess, ToastVariant.SUCCESS);
      store.dispatch("Org/fetchOrgList");
      EventEmitter.emit(EmitterEvents.REFRESH_ORG_DATA);
      handleCloseModal();
      EventEmitter.emit(
        EmitterEvents.APP_MODAL_MANAGE_ORGANISATIONS_VISIBILITY,
        form.nameDisplay || form.nameCode,
      );
    }
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Org.putOrgProfile);
    }
  }
};

const openVerifyOrgModal = (data: any) => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.VERIFY_ORG,
    properties: {
      orgName: data.nameShort ?? "",
      secretKey: data.secretKey,
    },
    events: {
      "close:modal": () => {
        store.dispatch("Org/fetchOrgList");
        EventEmitter.emit(EmitterEvents.REFRESH_ORG_DATA);
      },
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const onShowToast = (message: string, variant: ToastVariant) => {
  const emitData: IToastMessage = { variant, message };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
    if (value) initial();
  },
);

const initial = () => {
  notInfoVisible.value = true;
};

const handleLockStatus = () => {
  const isShowLockStatus =
    orgToOrgTypeIdOptions.value.find((org) => org.id === form.orgToOrgTypeId)
      ?.isLockable === true;
  if (isShowLockStatus) return true;
  else return false;
};

onMounted(() => {
  updateValidateRules();
});

const clearData = () => {
  for (const key in form) {
    if (Array.isArray(form[key])) {
      form[key].splice(0); // Clear the array content while maintaining reference
    } else {
      form[key] = initialForm[key];
    }
  }

  v$.value.$reset();
};

const handleCloseModal = () => {
  clearData();
  showRef.value = false;
  emit("update:show", showRef.value);
};

const fetchRoleMembersData = async () => {
  try {
    const responseData = await getOrgMembersAddable(currentOrg.value.id); //l
    const usersResponse = get(responseData, "data.data", []);
    superAdminUsers.value = usersResponse.map((user: any) => ({
      name: `${user.firstName} ${user.lastName}`,
      id: user.userId,
    }));
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Org.getAddableOrgMembers);
    }
  }
};

const fetchOrgToOrgTypeId = async () => {
  try {
    const orgToOrgTypeIdResponse = await fetchOrgAccessType();
    if (orgToOrgTypeIdResponse?.data?.data) {
      // only isLockable true relationship can be selected
      orgToOrgTypeIdOptions.value = orgToOrgTypeIdResponse.data.data
        .filter((relationship) => relationship.isLockable)
        .map((relationship) => ({
          name: relationship.name,
          id: relationship.id,
          isLockable: relationship.isLockable,
        }));
    }
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Org.getOrgAccessTypes);
    }
  }
};

const getFormData = async () => {
  if (isCreateOrg) {
    fetchOrgToOrgTypeId();
    fetchRoleMembersData();
  }
};

watch(
  () => currentOrg.value,
  (newValue, oldValue) => {
    if (newValue?.id && newValue?.id !== oldValue?.id) {
      getFormData();
    }
  },
  { deep: true, immediate: true },
);
</script>

<style lang="scss">
#appBarLayout {
  overflow-y: hidden;
}

.modal-create-org {
  overflow: auto;
}

.divider {
  border-top: 2px solid #eff0f1;
}

.create-organisation-button {
  border-radius: 100px;
  background: var(--brand-dark-sky, #387dff);
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
  padding: 8px 20px;
  color: var(--ui-white, #fff);
  text-align: center;
  font-family: Poppins;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;

  &:disabled {
    cursor: not-allowed;
    background: var(--ui-light-grey-50, #dbdbdb);
    color: var(--ui-light-grey, #b7b7b7);
    border: none;
  }
}
.gray-dropdown-container .show {
  color: #495057;
  background-color: #fff;
  border-color: #80bdff !important;
  outline: 0;
  -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25) !important;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25) !important;
}
.content {
  display: flex;

  .table-content {
    min-width: 100%;
  }
}
</style>
